import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon, UserCircleIcon, ArrowRightEndOnRectangleIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../../context/AuthContext';

const UserMenu: React.FC = () => {
  const { user, profile, signOut } = useAuth();

  const handleSignOut = async () => {
    try {
      const result = await signOut();
      if (!result.error) {
        // Force navigation to landing page after successful logout
        window.location.href = '/';
      }
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  if (!user || !profile) return null;

  return (
    <div className="flex items-center space-x-4">
      <div className="hidden md:block text-right">
        <p className="text-white font-semibold">{profile.fullName || profile.full_name || user.user_metadata?.full_name || 'User'}</p>
        <p className="text-lime-100 text-sm">{user.email}</p>
        <p className="text-lime-200 text-xs capitalize">{profile.userType || profile.user_type}</p>
      </div>

      <Menu as="div" className="relative z-[1000]">
        <Menu.Button className="flex items-center space-x-2 text-white hover:text-lime-100 transition-colors">
          <UserCircleIcon className="h-8 w-8" />
          <ChevronDownIcon className="h-4 w-4" />
        </Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 mt-2 w-64 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-[1000]">
            <div className="px-4 py-3">
              <p className="text-sm font-medium text-gray-900">
                {profile.fullName || profile.full_name || user.user_metadata?.full_name || 'User'}
              </p>
              <p className="text-sm text-gray-500">{user.email}</p>
              <p className="text-xs text-emerald-600 capitalize font-medium mt-1">
                {profile.userType || profile.user_type}
              </p>
            </div>

            <div className="py-1">
              <Menu.Item>
                {({ active }) => (
                  <button
                    type="button"
                    onClick={handleSignOut}
                    className={`${
                      active ? 'bg-red-50 text-red-700' : 'text-red-600'
                    } group flex w-full items-center px-4 py-2 text-sm font-medium hover:bg-red-50 hover:text-red-700 transition-colors`}
                  >
                    <ArrowRightEndOnRectangleIcon className="mr-3 h-4 w-4" />
                    Logout
                  </button>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};

export default UserMenu; 